import React from 'react'

const Paragraph: React.FC = ({ children }) => {
  return <p className="my-4">{children}</p>
}

export default Paragraph
